import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="container-static">
      <div className="header-section">
        <p className="main-header">プライバシーポリシー</p>
        <p className="sub-header">個人情報保護方針</p>
      </div>
      <dl className="defined type_normal">
        <dd className="defined type_normal">
          あんず（以下、当アプリケーション）におきまして、ユーザー（サービス利用者）は以下のポリシーに従い、当アプリケーションの個人情報の取り扱い方法に同意するものとします。
        </dd>
        <dd>
          <div className="lists has_number">
            <li>
              <div className="list-title">1.個人情報の収集について</div>
              当アプリケーションでは、ユーザーにサービスをご利用いただくために、以下の情報を収集する場合があります。
              <br />
              それらの個人情報は、会員個人にサービスを提供するために必要な情報ですので、その旨をご理解いただいたうえで、会員の個人情報をご登録いただいております。
              <br />
              会員から収集させていただいた個人情報は、不正アクセスや紛失ならびに漏洩等が起きぬよう、当サービスにて厳重に管理いたします。
              <br />
              ・氏名や生年月日
              <br />
              ・メールアドレスや電話番号
              <br />
              ・会員のデバイス情報やIPアドレスやCookie情報
            </li>
            <li>
              <div className="list-title">2.使用目的について</div>
              ご登録いただいた個人情報については、ユーザーにより良いサービスをご提供出来るよう利用させていただきます。
              <br />
              サービスの向上、会員との連絡等、カスタマサポートもしくはユーザーサポートに必要な情報として使用させていただきます。
              <br />
              なお、当アプリケーションからのご案内の停止/受信については、いつでも任意に「通知設定」より選択頂けます。
            </li>
            <li>
              <div className="list-title">3.情報の開示・提供について</div>
              当アプリケーションは、会員の同意なく、下記の場合を除き、個人情報を第三者へ開示または提供することは一切ありません。
              <br />
              ・当社と機密保持契約を締結している業務委託会社や協力会社
              （委託業務とは、請求処理、メールの送付等です。 ）
              <br />
              ・当社と機密保持契約を締結している業務委託会社や協力会社
              （委託業務とは、請求処理、メールの送付等です。 ）
              <br />
              ・警察など官公署からの要請
              <br />
              ・法律の適用を受ける場合（当アプリケーションは法律に基づく要請を受け、利用規約とその他の規定により、当社及び会員の権利、財産、安全を保護するため、情報の開示が必要であると認められた場合において、個人情報を開示・提供することがあります。）
            </li>
            <li>
              <div className="list-title">4.個人情報保護の遵守</div>
              収集した個人情報に関して適用される「個人情報保護に関する法律」（平成15年5月30日法律第57号）、日本工業規格「個人情報保護に関するコンプライアンス・プログラムの要求事項（JIS Q 15001）」及びその他の個人情報保護に関する規範を遵守します。
            </li>
          </div>
        </dd>
      </dl>
    </div>
  );
};

export default PrivacyPolicy;
